import { CurrencyLocation, DecimalSeparator, RoundingMethod, ThousandsSeparator } from '../../filters/currency/currency-formatter.const';
import { CurrencyOptions } from '../currency.interfaces';

export const PLN: CurrencyOptions = {
  currencyLocation: CurrencyLocation.PREPEND,
  currencySpacing: false,
  decimalDigits: 2,
  decimalSeparator: DecimalSeparator.COMMA,
  currencySymbol: 'zł',
  hideDecimalsIfZero: false,
  roundingMethod: RoundingMethod.ROUND,
  thousandsSeparator: ThousandsSeparator.NONE
};
